import React, { useEffect, useState } from "react";
import { Frame } from "@plutoxyz/react-frame";
import { getFrameUrl, getNotaryUrl, getWebSocketUrl } from "../../utils/utils";
export const WIDGET_MIN_HEIGHT = 650;
export const WIDGET_MAX_HEIGHT = 750;
export const WIDGET_MIN_WIDTH = 375;
export const WIDGET_MAX_WIDTH = 375;

const PlutoFrame = ({ code, onProof, onError }) => {
  return (
    <div className="px-4 md:px-8">
      <div
        className="pluto-frame-placeholder m-auto"
        style={{
          height: `clamp(${WIDGET_MIN_HEIGHT}px, 50vh, ${WIDGET_MAX_HEIGHT}px)`,
          width: `clamp(${WIDGET_MIN_WIDTH}px, 75vw, ${WIDGET_MAX_WIDTH}px)`,
          minHeight: `${WIDGET_MIN_HEIGHT}px`,
          minWidth: `${WIDGET_MIN_WIDTH}px`,
          maxHeight: `${WIDGET_MAX_HEIGHT}px`,
          maxWidth: `${WIDGET_MAX_WIDTH}px`,
        }}
      >
        <Frame
          className="relative z-10"
          script={code}
          onProof={onProof}
          onError={onError}
          brand={{
            logo: "https://storage.googleapis.com/pluto-brand-assets/assets/default-app.svg",
            name: "App Name",
          }}
          endpoints={{
            frame: getFrameUrl(),
            notary: getNotaryUrl(),
            socket: getWebSocketUrl(),
          }}
        />
      </div>
    </div>
  );
};

export default PlutoFrame;
